import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getTypesensePublishes = createAsyncThunk(
  "core/typesensePublishes/getTypesensePublishes",
  async (payload) => {
    try {
      const response = await coreAPIs.getTypesensePublishes(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
